import { PurchaseOptions } from "./PurchaseOptions";
import type { Price, StartGameProps } from "../PurchaseModal";
import type { StartPurchaseRet } from "@skillscratch/shared-types";
import { PurchaseLoading } from "./PurchaseLoading";
import { PurchaseSuccess } from "./PurchaseSuccess";
import type { PurchaseState } from "../PurchaseModal";
import { useTransitionAnimation } from "@/hooks/useTransitionAnimation";
import { CheckoutContent } from "@/components/CheckoutContent";


export function PurchaseContent({ 
    purchaseState, 
    handlePurchase,
    id,
    prices, 
    startGameProps,
    priceIdProp,
    result
}: { 
    purchaseState: PurchaseState, 
    handlePurchase: (priceId: string) => void,
    id: string,
    prices: Price[],
    result: StartPurchaseRet | undefined,
    startGameProps: StartGameProps | undefined,
    priceIdProp: string | undefined,
}) {
    const { 
        visibleState, 
        getAnimationClass 
    } = useTransitionAnimation<PurchaseState>(purchaseState, 300, [['checkout', 'checkout-failed']]);
    
    const renderStateContent = () => {
        switch (visibleState) {
            case 'options':
                return <PurchaseOptions onPurchase={handlePurchase} id={id} prices={prices} />;
            case 'checkout' as PurchaseState:
                return <CheckoutContent storeListingId={id} priceId={priceIdProp ?? ''} key={priceIdProp + id} purchaseId={result?.purchaseId ?? ''} />;
            case 'checkout-failed' as PurchaseState:
                return <CheckoutContent storeListingId={id} priceId={priceIdProp ?? ''} key={priceIdProp + id} purchaseId={result?.purchaseId ?? ''} />;
            case 'processing':
                return (
                    <div className="py-1 h-56 w-full relative flex items-center justify-center">
                        <PurchaseLoading />
                    </div>
                );
            case 'success':
                return (
                    <PurchaseSuccess startGameProps={startGameProps} 
                        priceIdProp={priceIdProp} />
                );
            default:
                return null;
        }
    };
    
    return (
        <div className="relative h-72">
            <div 
                className={`
                    absolute inset-0 w-full
                    transition-all duration-300 ease-in-out
                    ${getAnimationClass()}
                `}
            >
                {renderStateContent()}
            </div>
        </div>
    );
}